module.exports = __webpack_public_path__ + "img/Apple.9d1bc729.svg";